import { useFormikContext } from "formik"
import { RefObject, useEffect, useRef } from "react"

const UseFocusFirstInvalidField = ({
  fieldNameInputRefMap,
}: {
  fieldNameInputRefMap: {
    [fieldName: string]: RefObject<
      HTMLInputElement | HTMLButtonElement | HTMLSelectElement
    >
  }
}) => {
  const { submitCount, errors } = useFormikContext()

  const lastSubmitCount = useRef(0)
  const fieldToFocus = useRef<string | null>(null)

  useEffect(() => {
    // Only focus when submit count changes (form is submitted)
    if (lastSubmitCount.current === submitCount) return

    lastSubmitCount.current = submitCount

    // Capture the first invalid field at the time of submission
    const firstInvalidField = Object.keys(errors)[0]
    if (!firstInvalidField) return

    fieldToFocus.current = firstInvalidField

    // Focus the field once per submission
    setTimeout(() => {
      if (fieldToFocus.current) {
        fieldNameInputRefMap[fieldToFocus.current]?.current?.focus()
        fieldToFocus.current = null // Clear after focusing to prevent refocus
      }
    })
  }, [submitCount, fieldNameInputRefMap])

  return null
}

export default UseFocusFirstInvalidField
